/** Ordering and words for the team's Dialpad status, shared by the strip, the rail and tickets. */
import { type TeamMember } from '@lsc/contract';
import { presenceLabel } from '@lsc/domain';

const SUPPORT = 'support';

export const firstName = (name: string) => name.trim().split(/\s+/)[0] ?? name;

/** Support first, then other departments by name, then no department; by name inside each. */
export function byDepartment(team: TeamMember[]): { key: string; label: string; people: TeamMember[] }[] {
  const groups = new Map<string, { key: string; label: string; people: TeamMember[] }>();
  for (const m of team) {
    const key = m.department ?? '';
    const g = groups.get(key) ?? { key, label: m.departmentName ?? (key === '' ? 'No department' : key), people: [] };
    g.people.push(m);
    groups.set(key, g);
  }
  const rank = (k: string) => (k === SUPPORT ? 0 : k === '' ? 2 : 1);
  return [...groups.values()]
    .sort((a, b) => rank(a.key) - rank(b.key) || a.label.localeCompare(b.label))
    .map((g) => ({ ...g, people: [...g.people].sort((a, b) => a.name.localeCompare(b.name)) }));
}

/** "Busy", "Off duty, lunch". */
export function statusWords(m: TeamMember): string {
  const label = presenceLabel(m.word);
  return m.word === 'off_duty' && m.reason ? `${label}, ${m.reason.toLowerCase()}` : label;
}

/** The status dot, in the desk's status colours. */
export function statusDot(m: TeamMember): string {
  if (!m.onDuty) return 'bg-line-strong';
  if (m.word === 'available') return 'bg-live';
  if (m.word === 'unavailable') return 'bg-ink-3';
  return 'bg-attention';
}
